import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  goBackLevel: 0,
};

const centerSettings = createSlice({
  name: "centerSettings",
  initialState,
  reducers: {
    setGoBackLevel: (state, action) => {
      state.goBackLevel = action.payload;
    },
    reset: () => initialState,
  },
});

export const { setGoBackLevel, reset } = centerSettings.actions;

export default centerSettings.reducer;
